import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

// {{ $t("uploadFile") }}
// {{ this.$i18n.locale }}
const messages = {
  th: {
    welcomeMessage: 'ยินดีต้อนรับเข้าสู่ระบบทำแบบทดสอบออนไลน์',
    uploadFile: 'อัปโหลดไฟล์',
    uploadImage: 'อัปโหลดรูปภาพ',
    unableUploadFile: 'ไม่สามารถอัปโหลดไฟล์ได้ กรุณาลองใหม่',
    unableUploadImage: 'ไม่สามารถอัปโหลดรูปภาพได้ กรุณาลองใหม่',
    unableViewList: 'ไม่สามารถดูรายการแบบทดสอบได้ กรุณาลองใหม่',
    UnableLogin: 'ไม่สามารถเข้าสู่ระบบได้ กรุณาลองใหม่',
    example: '(ตัวอย่าง)',
    onlineExam: 'แบบทดสอบออนไลน์',
    exitPage: 'ออกจากหน้าสอบนี้',
    dialogExit1: 'ต้องการออกจากหน้านี้ใช่ไหม',
    dialogExit2: 'คุณแน่ใจหรือไม่ว่าต้องการออกจากหน้าดูตัวอย่างข้อสอบ',
    dialogExit3: 'คุณแน่ใจหรือไม่ว่าต้องการออกจากหน้านี้',
    dialogSave1: 'ต้องการส่งข้อสอบใช่ไหม',
    dialogSave2: 'คุณแน่ใจหรือไม่ว่าต้องการส่งข้อสอบ',
    submit1: 'ส่งคำตอบ',
    submit2: 'ยืนยัน',
    exit: 'ยืนยัน',
    cancel: 'ยกเลิก',
    exam: 'แบบทดสอบ',
    multipleChoice: 'ปรนัย',
    text: 'อัตนัย',
    attach: 'แนบไฟล์',
    testCount: 'ข้อ',
    teacherName: 'ชื่อผู้สอน',
    username: 'ชื่อผู้สอบ',
    usernameOrOne: 'ชื่อผู้ใช้งาน หรือ อีเมล One ID',
    password: 'รหัสผ่าน',
    forget_password: 'ลืมรหัสผ่าน',
    testDate: 'วันที่สอบ',
    timeLeft: 'เหลือเวลาสอบ',
    prev: 'ย้อนกลับ',
    next: 'ถัดไป',
    success: 'สำเร็จ',
    successPreview: 'ดูตัวอย่างสำเร็จ',
    informText1: 'ทั้งหมด',
    informText2: 'ตอบแล้ว',
    informText3: 'ยังไม่ตอบ',
    checkboxConsent: 'ยอมรับเงื่อนไข ข้อตกลงนี้ทั้งหมด?',
    updateConsent: 'ยอมรับและทำข้อสอบ',
    consentTitle: 'ไม่สามารถอัพเดท Consent ได้!',
    consentText: 'กดปุ่ม ตกลง เพื่อดำเนินการต่อ',
    consentBtn: 'ตกลง',
    status_Y: 'ผ่าน',
    status_N: 'ไม่ผ่าน',
    status_W: 'รอตรวจ',
    // status_NS: '',
    status_start: 'เริ่มทำข้อสอบ',
    status_waiting: 'ไม่อยู่ในช่วงสอบ',
    status_finished: 'สอบเสร็จแล้ว',
    noExamFound1: 'ไม่พบรายการแบบทดสอบ',
    noExamFound2: 'ไม่พบรายการแบบทดสอบที่ต้องการ',
    noExamFound3: 'กรุณาตรวจสอบใหม่อีกครั้งหรือ ติดต่อเจ้าหน้าที่ผู้ดูแล',
    order: 'ลำดับ',
    course_name: 'ชื่อคอร์ส',
    exam_name: 'แบบทดสอบ',
    start_time: 'วันที่เริ่มสอบ',
    end_time: 'วันที่สิ้นสุดการสอบ',
    number_of_exams: 'จำนวนข้อสอบ',
    score: 'คะแนนที่ได้',
    exam_time: 'ครั้งที่สอบ',
    status: 'สถานะ',
    login: 'เข้าสู่ระบบ',
    logout: 'ออกจากระบบ',
    search: 'ค้นหา',
    goToExam: 'ทำแบบทดสอบ',
    examProgress: 'ทำแบบทดสอบ / ทำแบบทดสอบต่อ',
    examPending: 'ไม่อยู่ในช่วงเวลาที่สอบ',
    examFinish: 'สอบเสร็จแล้ว',
    isBeforeTime: 'ยังไม่ถึงเวลาสอบ',
    isAfterTime: 'เลยระยะเวลาสอบแล้ว',
    textErr: 'ผิดพลาด',
    textWarning: 'คำเตือน',
    overRound: 'เกินจำนวนรอบในการสอบ',
    overtime_title: 'ท่านไม่มีสิทธิ์สอบในหน้านี้ หรือ ท่านได้สอบเกินครั้งที่กำหนดแล้ว',
    overtime_detail: 'ระบบกำลังนำท่านออกจากหน้านี้ในอีก',
    second: 'วินาที',
    pending_title: 'ขณะนี้ยังไม่ถึงเวลาสอบ',
    pending_detail1: 'เหลือเวลาอีก',
    pending_detail2: 'จนกว่าจะถึงเวลาสอบ',
    timeout_title1: 'หมดเวลาสอบ',
    timeout_title2: 'กรุณารอซักครู่',
    successful_submit: 'ส่งคำตอบสำเร็จ',
    wait_for_inspection: 'ส่งคำตอบสำเร็จ กรุณารอการตรวจ',
    network_unstable: 'เครือข่ายไม่เสถียร กรุณาตรวจสอบ Network ของท่าน และกดส่งคำตอบอีกครั้ง',
    imgLimit: '* จำกัดขนาดไฟล์ได้ไม่เกิน 10 mb',
    fileLimit: '* จำกัดขนาดไฟล์ได้ไม่เกิน 50 mb'

  },
  en: {
    welcomeMessage: 'Welcome to the online exam system.',
    uploadFile: 'Upload File',
    uploadImage: 'Upload Image',
    unableUploadFile: 'Unable to upload file. Please try again.',
    unableUploadImage: 'Unable to upload image. Please try again.',
    unableViewList: 'Unable to view the test list. Please try again.',
    UnableLogin: 'Unable to login. Please try again.',
    example: '(Example)',
    onlineExam: 'Online Test',
    exitPage: 'Exit this page',
    dialogExit1: 'Do you want to exit this page?',
    dialogExit2: 'Are you sure you want to exit the exam preview page?',
    dialogExit3: 'Are you sure to exit this page?',
    dialogSave1: 'Do you want to submit the exam?',
    dialogSave2: 'Are you sure to submit the exam?',
    submit1: 'Submit',
    submit2: 'Submit',
    exit: 'Exit',
    cancel: 'Cancel',
    exam: 'Exam',
    multipleChoice: ' Multiple Choice',
    text: ' Text',
    attach: ' Attach',
    testCount: '',
    teacherName: 'Teacher name',
    username: 'UserName',
    usernameOrOne: 'Username or One ID',
    password: 'Password',
    forget_password: 'Forget Password',
    testDate: 'Test Date',
    timeLeft: 'Exam Time Left',
    prev: 'Back',
    next: 'Next',
    success: 'success',
    successPreview: 'Successfully Previewed',
    informText1: 'Total',
    informText2: 'Answered',
    informText3: 'Not Answered',
    checkboxConsent: 'Do you accept all terms and conditions of this agreement?',
    updateConsent: 'Accept and take the exam',
    consentTitle: 'Unable to update Consent!',
    consentText: 'Press OK to continue.',
    consentBtn: 'OK',
    status_Y: 'Pass',
    status_N: 'Fail',
    status_W: 'Waiting for inspection',
    // status_NS: '',
    status_start: 'Start the exam',
    status_waiting: 'Not in exam period',
    status_finished: 'Finished',
    noExamFound1: 'No exam found',
    noExamFound2: 'No exam found',
    noExamFound3: 'Please check again or Contact the supervisor',
    order: 'Order',
    course_name: 'Course Name',
    exam_name: 'Exam Name',
    start_time: 'Start Time',
    end_time: 'End Time',
    number_of_exams: 'Number Of Exams',
    score: 'Score',
    exam_time: 'Exam Time',
    status: 'Status',
    login: 'Login',
    logout: 'Logout',
    search: 'Search',
    goToExam: 'Take the exam',
    examProgress: 'Take the Exam / Continue the Exam',
    examPending: 'Not at the exam time',
    examFinish: 'The exam has been completed',
    isBeforeTime: 'It is not time for the exam yet',
    isAfterTime: 'The exam period has passed',
    textErr: 'Error',
    textWarning: 'Warning',
    overRound: 'Exceeded the number of rounds in the exam',
    overtime_title: 'You are not eligible to take the test on this page or you have already taken the test more times than the allowed time.',
    overtime_detail: 'The system is removing you from this page.',
    second: 'second',
    pending_title: 'It is not yet time for the exam.',
    pending_detail1: 'There are',
    pending_detail2: 'left until the exam time.',
    timeout_title1: 'Time Out',
    timeout_title2: 'Please wait a moment.',
    successful_submit: 'Successfully submitted the answer.',
    wait_for_inspection: 'Successfully submitted the answer. Please wait for inspection.',
    network_unstable: 'The network is unstable. Please check your network and click to send the answer again.',
    imgLimit: '* File size is limited to 10 mb.',
    fileLimit: '* File size is limited to 50 mb.'

  },
};

const i18n = new VueI18n({
  locale: localStorage.getItem('language') || 'th', // ภาษาที่ใช้เริ่มต้น // ภาษาที่ใช้เริ่มต้น
  // locale: 'en',
  messages,
});

export default i18n;
